module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "prol02"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', {
    staticClass: "paraOpeningText"
  }, [_vm._v("M")]), _vm._v("y name is Veldmr. I understand that in your language it is not a beautiful name, but in my ancient language, now sadly lost, it had a particular musicality. Many parents were pleased to bestow it upon their sons.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I find it difficult to speak of my people. Their name cannot be translated out of our lost language, but the concept, perhaps, can. It comes close to ’river angel‘ . . . We once were the River Angels.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A long, long time ago.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("We danced and sprang through the rivers and lakes of this world. Not the oceans — they were too tumultuous for us, and liked us not — but every body of water cradled within the landmass contained a number of our people. We were part spirit, part joy, part wraith, part flesh. We were formed in mystery and existed in enchantment.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("We were truly astounding.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("No other race who has come after can compare, although the Icarii now like to think "), _c('i', [_vm._v("they")]), _vm._v(" take the honours in mystery and musicality. Ha!")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Ah, hark to my pride. I should learn to better subdue it.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("For aeons we danced amid the waters, largely lost within ourselves, minding none of the other creatures which inhabited this world. Races like the Icarii or humans did not exist then. I speak of a time at the very beginning of the world, when mystery ruled triumphant and flesh and its continuance did not matter as it does now.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("We danced, we sang, we explored countless secrets. We came to understand creation itself. We knew about Infinity. We knew of it, but we did not care. Even Infinity was of no matter to us.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('i', [_vm._v("We were the River Angels.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Nothing mattered but ourselves and the waters which cradled us.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("One day, another among our number decided that there was no other race or creature in this world that mattered, save us. Creation could never manage a more magnificent creature than ourselves.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("We were the pinnacle of life, and of learning, and the culmination of all mysteries.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("This creed spread rapidly throughout the River Angels. We believed it utterly, and it became part of the fabric of our existence. We pitied every other creature within and without water.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("They had no matter in life. No point.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Then another one among us supposed that if they mattered not, and if they had no point, then they should be despised.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("That idea, too, gained great currency among the River Angels, and soon we despised all creatures not of our number.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("They were pointless, a drain on creation. They marred our world, our very existence.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('i', [_vm._v("They needed to go.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Thus began our campaign of murder. It is not what we called it, then, but I have enough wisdom and grace now to see it for what it was. Murder. Rampant massacre.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("All other creatures depended on water. They needed to drink of it; they needed to eat the creatures within it; they needed it to dampen their roots.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Everyone came to water, sooner or later.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("And, as they did so, we murdered them.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Insects; great hoofed creatures; birds of the sky. As soon as they bent to drink from the water, they were seized in our malicious, prideful hands and slaughtered.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("We tore out plants, even great trees of the forests, and drowned them as soon as their roots touched our domain.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("No one should be allowed to exist save us.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Oh, we were such disgusting creatures!")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Naturally, such wholesale butchery did not go unnoticed. One day our god came to us and he asked us what we did.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("We explained. We told him that none mattered save us, and that we intended to rid our world of all creatures that had no point to their existence.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Everyone save us.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("And our god, of course. We could tolerate his presence.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Ah, I cannot explain to you the depth of our god’s wrath. Initially, we could not understand it — unbelievable as that sounds — for were we not committed to the most practical of works?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("His wrath deepened. He asked us to forbear our madness, but as we did not understand it as such, we could not comprehend our god’s wrath (such shallow creatures we were!), and thus we could not acquiesce to his wishes.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("More creatures and plants died.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Thus, our god destroyed us. Such a simple thing to say — four words to describe the most appalling time.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He destroyed us. The water was removed from us, and we could never more touch it. We were condemned to wander within the air, we were condemned to hate the element which had once cradled us and we were condemned to be hated and despised by all who met us.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("We became The Hated, and we existed only in horror.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Worst of all, we lost our god, our beloved, and we have spent aeons looking for him again. Sometimes we think we have found him, or something, someone, who might replace him.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("But they have never come close to he who we lost.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The god of the waters, who so long ago turned his back on us.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c865ee4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/unknown.vue
// module id = 75
// module chunks = 0